module.exports = __webpack_public_path__ + "media/icons/naped-przod-ef164420.png";